import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../core/store';
import { Destroyable } from '../../../../core/util/destroyable';
import { AuthorizationMatrix } from '../../../../core/store/session/authorization/authorization.interface';
import { ContractInfo } from '../../../../core/store/contract-info/contract-info.interface';
import { goAction } from '../../../../core/store/router/router.actions';

@Component({
  selector: 'app-dashboard-orders-tile',
  templateUrl: './orders-tile.component.html',
  styleUrls: ['../common/orders-flows-tile.component.scss'],
})
export class OrdersTileComponent extends Destroyable implements OnChanges {
  @Input() authorization: AuthorizationMatrix;
  @Input() contractInfo: ContractInfo;
  showCreate = false;

  constructor(protected store: Store<fromRoot.RootState>) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.showCreate = this.authorization?.ORDER?.CREATE;
  }

  createOrderClicked() {
    this.store.dispatch(goAction({ path: `orders/new` }));
  }

  viewOrdersClicked() {
    this.store.dispatch(goAction({ path: `orders/execute-clean-filter` }));
  }
}
